import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { User } from '@wilson/interfaces';
import { Observable, filter, of, switchMap } from 'rxjs';
import { FetchAllUsersIfNeeded } from '../users-state/users-state.action';
import { UsersState } from '../users-state/users-state.state';

@Pipe({
  name: 'getUserById',
  standalone: true,
})
export class GetUserByIdPipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(id: string | null | undefined): Observable<User | undefined> {
    if (!id) {
      return of(undefined);
    }

    return this.store.dispatch(new FetchAllUsersIfNeeded()).pipe(
      switchMap(() => this.store.select(UsersState.userById(id))),
      filter((user) => !!user),
    );
  }
}
